import { useQueryClient } from "@tanstack/react-query";

import {
  getGetDefaultSLAQueryKey,
  useGetDefaultSLA,
  useUpdateDefaultSLA,
} from "@vega-api/generated/case-admin-v1/case-admin-v1";
import { useToast } from "@vega-core/components/Toast/useToast";
import { m } from "@vega-core/paraglide/messages";

import { useMutationErrorToast } from "../../hooks/useMutationErrorToast";
import { SlaInlineEditor } from "../SlaInlineEditor/SlaInlineEditor";

export const DefaultTriageSlaCard = () => {
  const showToast = useToast();
  const errorToast = useMutationErrorToast();
  const queryClient = useQueryClient();

  const { data: defaultSlaData, isLoading } = useGetDefaultSLA();

  const { mutate: updateDefaultSla, isPending } = useUpdateDefaultSLA({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getGetDefaultSLAQueryKey() });
        showToast({
          title: m.cases_settings_success_updateDefaultSla(),
          variant: "success",
        });
      },
      onError: errorToast(m.cases_settings_error_updateDefaultSla()),
    },
  });

  return (
    <section
      className="rounded-companyBorderRadius border border-border/primary p-6"
      data-testid="default-triage-sla-card"
    >
      {!isLoading && (
        <div className="flex items-center justify-between gap-4">
          <div className="space-y-1">
            <span className="body-base-medium">
              {m.cases_settings_defaultSla_label()}
            </span>
            <p className="body-small-regular text-text/secondary">
              {m.cases_settings_defaultTriage_description()}
            </p>
          </div>
          <SlaInlineEditor
            editLabel={m.cases_settings_defaultSla_label()}
            hours={defaultSlaData?.data.slaInHours}
            isPending={isPending}
            name="default-triage-sla"
            onSave={(hours) =>
              updateDefaultSla({ data: { totalSlaInHours: hours } })
            }
          />
        </div>
      )}
    </section>
  );
};
